export default "__VITE_ASSET__567ba79f__"